export const Assets = [ 'icon', 'illustration', 'photo' ]

export const PreviewSizes = [ 'lg', 'md', 'sm' ]

export const Themes = [ 'light', 'dark' ]

export const Sort = [ 'popular', 'latest', 'relevant' ]

export const Pricing = [ 'free', 'premium' ]

export const IconFormats = ['svg', 'png']

export const IllustrationFormats = ['thumb', 'original', 'svg']

export const PhotoFormats = ['thumb', 'original']

export const FillTypes = ['fill', 'mask']

export const ImageSizeDimensions = {
  'thumb': 450,
  'hd': 2880,
  'original': null
}

export const SearchColors = [
  '#e51c23',
  '#e91e63',
  '#9c27b0',
  '#673ab7',
  '#3f51b5',
  '#5677fc',
  '#03a9f4',
  '#00bcd4',
  '#009688',
  '#259b24',
  '#8bc34a',
  '#cddc39',
  '#ffeb3b',
  '#ffc107',
  '#ff9800',
  '#ff5722',
  '#795548',
  '#9e9e9e',
  '#607d8b'
]
